import { loadingParts } from './config';
export class GameStats {
    loadingStats = {
        startTime: 0,
        endTime: 0,
        partBeforeLoader: 0,
        partFirstInit: 0,
        partInitRequest: 0,
        partLoadingAssets: 0,
        partSecondInit: 0
    };
    loadingPartActual = 0;
    disciplineDataToLog = {};
    exitedGame = false;
    setLoadingStats(type, time = new Date().getTime()) {
        this.loadingStats[type] = time;
    }
    getLoadingStats(type) {
        return this.loadingStats[type];
    }
    getDiffLoadingStats(type1, type2) {
        return this.getLoadingStats(type1) - this.getLoadingStats(type2);
    }
    setNextLoadingPart() {
        this.loadingPartActual++;
    }
    getLoadingProgress() {
        return this.loadingPartActual / loadingParts * 100;
    }
    setDisciplineDataToLog(data) {
        this.disciplineDataToLog = data;
    }
    getDisciplineDataToLog() {
        return this.disciplineDataToLog;
    }
    setExitedGame(exitedGame) {
        this.exitedGame = exitedGame;
    }
    wasExitedGame() {
        return this.exitedGame;
    }
}
//# sourceMappingURL=GameStats.js.map